import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import AvatarEditor from "../../Components/Forms/AvatarEditor";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";
import L from 'leaflet';
// Libraries
import Form from "react-bootstrap/Form";
import { apiService } from "../../Axios/apiService"; 

import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.js";


export default function EditUser() {
    const params = useParams();
    const { user } = useAuthContext();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [formErrors, setFormErrors] = useState({ firstName: "" });
    const [loading, setLoading] = useState(true);
    const [resetPassword, setResetPassword] = useState(false);

    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);


    const [form, setForm] = useState({
        livestock: [],
        companiesSupplied: []
    });

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {

        if (isValid) {
            setSubmitting(true);

            console.log("submitting form:", form); 


                apiService("put", `farms/${form.id}`, form,
                    (response) => {
                        console.log("response:", response);
                        setSubmitting(false);

                        navigate(`/Farms/View/${response.id}`)
                        
                    },
                    (error) => {
                        console.log(error.response.data);
                        setSubmitting(false);

                        if (error.code === "ERR_NETWORK") {
                            setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                        }
                        else if (error.code === "ERR_BAD_REQUEST") {
                            setFormErrors(error.response.data.errors);
                        }
                        else {
                            setFormErrors({ general: "An unknown error occured. " + error.code });
                        }
                    }
                )




           
        }
    }, [isValid]);

    useEffect(() => {
        setIsValid(formErrors.name === "" && formErrors.businessName === "")
    }, [formErrors])

    useEffect(() => {

        // look up the postcode
        if (isUKPostCode(form.postcode)) {
            console.log("postcode changed");

            const geocoder = new L.Control.Geocoder.Nominatim();
            geocoder.geocode(form.postcode, function (results) {


                setForm({
                    ...form,
                    ["latitude"]: results[0].center.lat,
                    ["longitude"]: results[0].center.lng,
                });
            });
        }

    }, [form.postcode])

    // Load user
    useEffect(() => {
        console.log("loading farm...", params.id);


        axios
            .get(`https://${process.env.REACT_APP_IP}/api/farms/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Farm:", res.data);
                setForm({
                    ...res.data,
                    livestock: res.data.livestock || [], // ? ensure it�s always an array
                    companiesSupplied: res.data.companiesSupplied || []
                });
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });

    }, [])


    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            name: form.name === undefined || form.name === "" ? "Farm name is required" : "",
            businessName: form.businessName === undefined || form.businessName === "" ? "Business name is required" : ""
        });
    }

    

    function isUKPostCode(str) {
        const regexp = /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/;

        if (regexp.test(str)) {
            return true;
        }
        else {
            return false;
        }
    }

    const handleAddCompanySupplied = (value) => {
        // prevent duplicates
        if (form.companiesSupplied.includes(value)) return;

        setField("companiesSupplied", [...form.companiesSupplied, value]);
    };

    const handleRemoveCompanySupplied = (index) => {
        setField(
            "companiesSupplied",
            form.companiesSupplied.filter((_, i) => i !== index)
        );
    }



    return (
        <div className="page">
            {submitting && (
                <SubmittingDialog />
            )}
            {loading && (<Spinner />)}
            {!loading && form && (
                <>

                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <h1>
                                        Edit Farm
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Form onSubmit={handleSubmit} noValidate >

                        
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">

                                    { /* Farm Name */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Farm Name</label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g John Smith Farm"
                                                isInvalid={formErrors && formErrors.name}
                                                onChange={(e) => setField("name", e.target.value)}
                                                value={form.name ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.name}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>

                                    { /* Business Name */}
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Business Name</label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="e.g John Smith Farms Ltd"
                                                isInvalid={formErrors && formErrors.businessName}
                                                onChange={(e) => setField("businessName", e.target.value)}
                                                value={form.businessName ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.businessName}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">

                                {  /* Address Section Header */  }
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 style={{ marginTop: 20 }}>Address</h3>
                                    </div>
                                </div>


                                { /* Address */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Address</label>
                                            <Form.Control as="textarea" rows="5"
                                                placeholder="e.g Suite 12B"
                                                isInvalid={formErrors && formErrors.address}
                                                onChange={(e) => setField("address", e.target.value)}
                                                value={form.address ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.address}
                                            </Form.Control.Feedback>
                                            </div>
                                    </div>
                                </div>

                                { /* Postcode */}
                                <div className="row">
                                    <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Postcode</label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="e.g CA1 1AA"
                                                    isInvalid={formErrors && formErrors.postcode}
                                                    onChange={(e) => setField("postcode", e.target.value)}
                                                    value={form.postcode ?? ""}
                                                />
                                                <Form.Control.Feedback className="text-danger" type="invalid">
                                                    {formErrors.postcode}
                                                </Form.Control.Feedback>
                                            </div>
                                    </div>
                                </div>
                            </div>
                 
                            <div className="col-md-6">

                                {  /* Primary Contact Section Header */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 style={{ marginTop: 20 }}>Primary Contact</h3>
                                    </div>
                                </div>

                                { /* Name */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <Form.Control
                                                type="text"
                                                placeholder="e.g Joe Bloggs"
                                                isInvalid={formErrors && formErrors.primaryContact}
                                                onChange={(e) => setField("primaryContact", e.target.value)}
                                                value={form.primaryContact ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.primaryContact}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>

                                { /* Telephone */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Telephone</label>
                                            <Form.Control
                                                type="tel"
                                                placeholder="e.g 01228 123456"
                                                isInvalid={formErrors && formErrors.telephone}
                                                onChange={(e) => setField("telephone", e.target.value)}
                                                value={form.telephone ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.telephone}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>

                                { /* Email */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Email</label>
                                            <Form.Control
                                                type="email"
                                                placeholder="e.g john@smith.com"
                                                isInvalid={formErrors && formErrors.email}
                                                onChange={(e) => setField("email", e.target.value)}
                                                value={form.email ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.email}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                    
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">

                                {  /* Primary Contact Section Header */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 style={{ marginTop: 20 }}>Details</h3>
                                    </div>
                                </div>

                                { /* Referred By */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Referred By</label>
                                            <div className="select">
                                                <Form.Select
                                                    onChange={e => setField("referredBy", e.target.value)}
                                                    value={form.referredBy || ""}
                                                >
                                                    <option value="" >Please Select...</option>
                                                    <option value="ADAS">ADAS</option>
                                                    <option value="Agrovista">Agrovista</option>
                                                    <option value="Aspatria">Aspatria</option>
                                                    <option value="Eco Prospects">Eco Prospects</option>
                                                    <option value="Glasson">Glasson</option>
                                                    <option value="Mitchells">Mitchells</option>
                                                    <option value="NWA">NWA</option>
                                                    <option value="Other">Other</option>

                                                </Form.Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                { /* SBI */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>SBI</label>
                                            <Form.Control
                                                type="number"
                                                placeholder="e.g 123456789"
                                                isInvalid={formErrors && formErrors.sbi}
                                                onChange={(e) => setField("sbi", e.target.value)}
                                                value={form.sbi ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.sbi}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>

                                { /* Companys Supplied */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Companies Supplied</label>
                                            <br/>
                                            {form.companiesSupplied && form.companiesSupplied.map((item, index) => (
                                                <span
                                                    key={index}
                                                    style={{
                                                        minWidth: 50,
                                                        display: "inline-block",
                                                        border: "1px solid #ccc",
                                                        padding: "2px 6px",
                                                        background: "#f1f1f1",
                                                        marginRight: 6,
                                                        borderRadius: 4,
                                                        marginTop: 10,
                                                        marginBottom: 10
                                                    }}
                                                >
                                                    {item} <a href="#" style={{ marginLeft: 10 }} onClick={() => handleRemoveCompanySupplied(index)}>x</a>
                                                </span>
                                            ))}


                                            <div className="select">
                                                <Form.Select
                                                    onChange={e => handleAddCompanySupplied(e.target.value)}
                                                >
                                                    <option value="" >Please Select...</option>
                                                    <option value="Arla">Arla</option>
                                                    <option value="ABP">ABP</option>
                                                    <option value="Dunbia">Dunbia</option>
                                                    <option value="First Milk">First Milk</option>
                                                    <option value="Lanchester">Lanchester</option>
                                                    <option value="Meadow Foods">Meadow Foods</option>
                                                    <option value="Muller">Muller</option>
                                                    <option value="Nestle">Nestle</option>
                                                    <option value="Paynes Dairies">Paynes Dairies</option>

                                                </Form.Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                { /* NVZ */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Is The Farm Located In An NVZ?</label>
                                            <Form.Check
                                                type="checkbox"
                                                label="Yes"
                                                onChange={(e) => setField("nvz", e.target.checked)}
                                                checked={form.nvz}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.nvz}
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


           
            
                        

                        <hr />

                        {formErrors.general && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-danger">
                                            {formErrors.general}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-md-12">
                                <button className="btn btn-primary">Update Farm</button>
                                <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Farms/`) }}>Cancel</button>
                            </div>
                        </div>
                    </Form>
                </>
            )}
        </div>
  )
}
